import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';


/**
 * Company & Brand Information
 */
export const COMPANY = {
  name: 'Centralized Smart Attendance Solution',
  shortName: 'CSAS',
  email: 'contact@csas.com',
  phone: '+1 (555) 123-4567',
  logo: '/assets/logos/csas-logo.png',
  logoTransparent: '/assets/logos/csas-transparent-logo.png',
  logoWhite: '/assets/logos/csas-white-logo.png',
  address: {
    street: '123 Smart Street',
    city: 'Smart City, SC 12345'
  },
  businessHours: [
    { days: 'Monday - Friday', hours: '9AM - 6PM' },
    { days: 'Saturday', hours: '10AM - 4PM' }
  ],
  copyright: '© 2025 CSAS. All rights reserved.'
};


/**
 * Social media links
 */
export const SOCIAL_LINKS = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' }
];

/**
 * Common UI constants
 */
export const DAYS_OF_WEEK = [
  { value: 'mon', label: 'Monday' },
  { value: 'tue', label: 'Tuesday' },
  { value: 'wed', label: 'Wednesday' },
  { value: 'thu', label: 'Thursday' },
  { value: 'fri', label: 'Friday' },
  { value: 'sat', label: 'Saturday' },
  { value: 'sun', label: 'Sunday' },
];

export const BREAK_MINUTES_OPTIONS = [
  { value: '0', label: '0' },
  { value: '30', label: '30' },
  { value: '45', label: '45' },
  { value: '60', label: '60' },
  { value: '90', label: '90' },
];

export const ROLES = [
  { slug: 'guest', name: 'Guest' },
  { slug: 'admin', name: 'Admin' },
];

export const ROLE_SELECT_OPTIONS = ROLES.map(r => ({ value: r.slug, label: r.name }));

export const FLEXIBLE_OPTIONS = [
  { value: 'no', label: 'No' },
  { value: 'yes', label: 'Yes' },
];

/**
 * Registration-related options
 */
export const DEVICE_TYPE_OPTIONS = [
  { value: 'time-in', label: 'Time In' },
  { value: 'time-out', label: 'Time Out' },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'Full-Time', label: 'Full-Time' },
  { value: 'Part-Time', label: 'Part-Time' },
  { value: 'Contractual', label: 'Contractual' },
  { value: 'Intern', label: 'Intern' },
  { value: 'Volunteer', label: 'Volunteer' },
];